import type { ReactNode } from 'react';

export const ToastType = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export interface ToastProps {
  content: ReactNode;
  type: (typeof ToastType)[keyof typeof ToastType];
  duration?: number;
}
